import axios from 'axios';
import { GetContractTypeDataType } from 'store/contract/types';
import { getApiBaseUrl, getApiBaseGatewayUrl } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();
const baseUrlGetway = getApiBaseGatewayUrl();

export function getContractsTypeApi(data: GetContractTypeDataType) {
  return axios.get(`${baseUrl}/params/typeContracts?language=${data.language}`);
}

export function verifyEligibilityByContractNotnumApi({
  dataToSend,
  isUserFound,
}: any) {
  if (isUserFound)
    return axios.post(`${baseUrl}/user/verifyByContract`, dataToSend);
  else
    return axios.post(
      `${baseUrl}/user/verifyUnidentifiedUserByContract`,
      dataToSend,
    );
}
export function getContractsAutoApi() {
  return axiosInstance.get('/contractsAuto');
}

export function getDetailContractApi(data: any) {
  return axiosInstance.get(
    `/contracts/details?contract=${data.policyNumber}&lang=${data.lang}&circulationDate=${data.circulationDate}`,
  );
}
export function getContractMRHApi() {
  return axiosInstance.get('/contractsMRH');
}
export function addNewContractApi(data: any) {
  return axios.post(`${baseUrl}/user/addNewContract`, data);
}
export function getDetailsContractMrhApi(data: any) {
  return axiosInstance.get(
    `/contractsMRH/details?contract=${data.policyNumber}&lang=${data.lang}`,
  );
}
export function getContractsEpargnApi(payload: any) {
  return axios.post(`${baseUrlGetway}/epargn/get-all-policies`, payload);
}

export function getContractsEpargnApiV2(payload: any) {
  return axios.post(`${baseUrlGetway}/epargn/v2/get-all-policies`, payload);
}

export function getInfoProduitApi() {
  return axios.post(`${baseUrlGetway}/epargn/get-info-produit`);
}

export function getContractsAmcApi() {
  return axiosInstance.get('/health/getContractsAmc');
}

export function getContractAMCDetailsApi(payload: any) {
  return Promise.all(
    payload.policyNumbers.map((policyNumber: string) =>
      axiosInstance.get(
        `/health/contractDetail?language=${payload.language}&policyNumber=${policyNumber}`,
      ),
    ),
  );
}

export function getContractAMCBeneficiariesApi() {
  return axiosInstance.get(`/health/getbeneficiaryAMC`);
}

export function getContractASIApi(payload: { language: string }) {
  return axiosInstance.get(`/asi/clientContract?language=${payload.language}`);
}
